const featureItems = [
  {
    icon: 'ri-book-read-line',
    title: '完结漫画大全',
    desc: '只收录已完结的漫画全集，告别追更焦虑，从第一章直接读到大结局。',
  },
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式滚动阅读',
    desc: '竖屏连续滚动，无需翻页点击。所有漫画内容一页到底，沉浸阅读不中断。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '手机端完美适配',
    desc: '移动浏览器即开即看，无需下载 App。竖屏排版自动适配，躺着也能爽看漫画。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新推荐',
    desc: '完结漫画推荐榜单每日刷新，根据热度和口碑持续为你推荐值得补的完结作品。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '免费安全阅读',
    desc: '所有漫画全集免费阅读，无需注册付费。页面纯净无弹窗，专注漫画阅读体验。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            为什么选择迷妹漫画
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            五大核心优势，打造最舒适的完结漫画在线阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 max-w-6xl mx-auto">
          {featureItems.map((item, i) => (
            <div
              key={i}
              className="text-center p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/60 transition-all duration-200 hover:-translate-y-1"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-2xl bg-accent-100/80 flex items-center justify-center">
                <i className={`${item.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading text-foreground-950 mb-2">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}